import { FileType } from '@office-start/document-types';
export function getFileNativeUriScheme(fileType) {
    switch (fileType) {
        case FileType.Word:
            return 'ms-word:ofe|u|';
        case FileType.Excel:
            return 'ms-excel:ofv|ofc|u|';
        case FileType.Visio:
            return 'ms-visio:ofe|u|';
        case FileType.PowerPoint:
            return 'ms-powerpoint:ofe|u|';
        case FileType.OneNote:
            return 'onenote:';
    }
    return undefined;
}
//# sourceMappingURL=getFileNativeUriScheme.js.map